<template>
  <div class="section">
    <div class="columns is-centered">
      <div
        class="column is-full-mobile is-8-tablet is-5-desktop is-3-widescreen is-3-fullhd"
        style="text-align: center"
      >
        <h1 class="title is-4">Neues Passwort erstellen</h1>
        <div v-if="data === true" class="block">
          <b-message type="is-success">
            Ihr Passwort wurde geändert, Sie können sich jetzt anmelden.
          </b-message>
          <b-button tag="router-link" :to="{ name: 'Login' }" expanded>
            zum Login
          </b-button>
        </div>
        <div v-else>
          <div v-if="error" class="block">
            <b-message type="is-danger">
              {{ error }}
            </b-message>
          </div>
          <div class="block">
            <ValidationObserver
              ref="observer"
              v-slot="{ handleSubmit, invalid }"
            >
              <div
                v-on:keyup.enter="handleSubmit(submit)"
                style="text-align: left"
              >
                <div class="block">
                  <BInputWithValidation
                    rules="required|min:6"
                    type="password"
                    label="Passwort"
                    v-model="new_password"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <BInputWithValidation
                    :rules="`required|is:${new_password}`"
                    type="password"
                    label="Passwort wiederholen"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <b-button
                    type="is-outlined is-gold"
                    expanded
                    :disabled="invalid"
                    :loading="loading"
                    @click="handleSubmit(submit)"
                  >
                    Password ändern
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'Signup',
  components: {
    BInputWithValidation,
  },
  data() {
    return {
      token: this.$route.query.token || 0,
      new_password: null,
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('auth/passwordReset/PUSH', { token: this.token, new_password: this.new_password });
    },
  },
  computed: {
    ...mapGetters({ data: 'auth/passwordReset/data', error: 'auth/passwordReset/error', loading: 'auth/passwordReset/loading' }),
  },
  mounted() {
    this.$store.commit('auth/passwordReset/SET_DATA_CLEAR');
    this.$store.commit('auth/passwordReset/CLEAR_ERROR');
  },
};
</script>
